import { render, staticRenderFns } from "./buyerLevel.vue?vue&type=template&id=0607176e&"
import script from "./buyerLevel.vue?vue&type=script&lang=js&"
export * from "./buyerLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports